import React from "react"
import { Switch, Route, Redirect } from "react-router-dom"

import routes from "./Routes"

const RouterSwitch = (props: any) => {
  const Re = () => <Redirect to="/" />
  return (
    <Switch>
      {routes.map((route, i) => {
        const Comp = route.component
        return (
          <Route
            key={i}
            exact={typeof route.exact !== "undefined" ? route.exact : true}
            path={route.routePath || route.path}
            component={Comp}
          />
        )
      })}
      <Route component={Re} />
    </Switch>
  )
}

export default RouterSwitch
